import { useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";

const useApiGet = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const getData = async (url, contentType = "application/json") => {
    const token = Cookies.get("TheShow_Admin_Token");
    const apiUrl = process.env.REACT_APP_API_URL.replace(/\/$/, ""); // remove trailing slash

    try {
      setLoading(true);
      setError(null);

      const headers = {
        "Content-Type": contentType,
        ...(token && { Authorization: `Bearer ${token}` }),
      };

      const response = await axios.get(
        `${apiUrl}${url}`,
        { headers }
      );

      setData(response.data);
      return response.data;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { loading, error, data, getData };
};

export default useApiGet;
